// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ProgressSpinner_spinner__9mSUL","lds-spinner":"ProgressSpinner_lds-spinner__2mVKo"};